<template>
  <div class="container">
    <div class="page">
      <div class="read">
           <img class="readImg1" src="../assets/img/read/readtitle.png" alt="">
           <img class="readImg2" src="../assets/img/read/read.png" alt="">
      </div>
      <div class="haoqi">
           <img class="haoqiImg1" src="../assets/img/read/haoqititle.png" alt="">
           <img class="haoqiImg2" src="../assets/img/read/haoqi.png" alt="">
      </div>
      <div class="product">
        <img class="product-img1" src="../assets/img/read/title.png" alt="" />
        <div class="productback">
          <img
            class="product-img2"
            src="../assets/img/read/productbook.png"
            alt=""
          />
          <img
            class="product-img3"
            src="../assets/img/read/decorate.png"
            alt=""
          />
        </div>
        <a href="https://haohuo.jinritemai.com/views/product/detail?id=3542815323373844343&origin_type=604"  >
        <img
          class="product-img4"
          src="../assets/img/read/knowmore.png"
          alt=""
        />
        </a>
        
      </div>
      <div class="recommendPage">
        <swiper
          v-if="bannerImg.length > 1"
          :options="swiperOption1"
          ref="mySwiper"
          style="width: 78%;"
        >
          <swiper-Slide v-for="(item, index) in bannerImg" :key="index"
            ><img
              class="swiper-img"
              :src="item.img"
              @click="changeBanner(item, index)"
              alt=""
          /></swiper-Slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="swiper-button-prev" @click="swiperPreOne"></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="swiperNextOne"
        ></div>
      </div>
      <div class="mouse">
        <span class="mousetitle">小蜜鼠来咯</span>
        <span class="mousetext"
          >“小蜜鼠”暖心绘本一套八本，讲述了小蜜鼠个子很矮，可是这样的小个头却和好朋友们经历了许多不平凡的事儿。大方、友善、自信、乐观，这些就是小蜜鼠快乐心情的源泉和基石，每一册都是一个成长的故事，每一册，都试图让这些好的性格浸润孩子，温暖心灵。</span
        >
      </div>
      <div class="newbook">
        <img class="newbookImg" src="../assets/img/read/newbook.png" alt="" />
        <!-- <img class="new" src="../assets/img/read/new.png" alt=""> -->
        <div class="newbook-banner">
          <swiper
            v-if="bannerImg.length > 1"
            :options="swiperOption2"
            ref="mySwiperTwo"
            style="width: 90%;"
          >
            <swiper-Slide v-for="(item, index) in bannerBookImg" :key="index"
              ><img class="swiper-img" :src="item.img" alt=""
            /></swiper-Slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="swiper-button-prev" @click="swiperPreTwo"></div>
          <div class="bannerpros">
            <!-- <img
              class="bannerpro"
              src="../assets/img/read/bannerpros.png"
              alt=""
            />
            <img
              class="bannerpro"
              src="../assets/img/read/bannerpros.png"
              alt=""
            />
            <img
              class="bannerpro"
              src="../assets/img/read/bannerpro.png"
              alt=""
            />
            <img
              class="bannerpro"
              src="../assets/img/read/bannerpros.png"
              alt=""
            />
            <img
              class="bannerpro"
              src="../assets/img/read/bannerpros.png"
              alt=""
            /> -->
            <div  :class="bannerNum == 1?'bannerpro-active':'bannerpro'"></div>
            <div :class="bannerNum == 2?'bannerpro-active':'bannerpro'"></div>
            <div :class="bannerNum == 3?'bannerpro-active':'bannerpro'"></div>
            <div  :class="bannerNum == 4?'bannerpro-active':'bannerpro'"></div>
            <div  :class="bannerNum == 5?'bannerpro-active':'bannerpro'"></div>
          </div>
          <div
            class="swiper-button-next"
            slot="button-next"
            @click="swiperNextTwo"
          ></div>
        </div>
      </div>
      <div class="planner">
        <img class="plannerImg" src="../assets/img/read/planner.png" alt="" />
        <img
          class="plannermes"
          src="../assets/img/read/plannermes.png"
          alt=""
        />
      </div>
      <div class="partner">
        <img class="partnerImg" src="../assets/img/read/partner.png" alt="" />
        <div class="partlist">
          <img src="../assets/img/read/part1.png" alt="" />
          <img src="../assets/img/read/part2.png" alt="" />
          <img src="../assets/img/read/part3.png" alt="" />
          <img src="../assets/img/read/part4.png" alt="" />
          <img src="../assets/img/read/part5.png" alt="" />
          <img src="../assets/img/read/part6.png" alt="" />
        </div>
      </div>
      <div class="retailer">
                 
        <div class="retailer-name">
          <input
            id="distributor_name"
            placeholder="经销商名称"
            autocomplete="off"
            v-model="formData.distributor_name"
            input-align="left"
            :rules="[{ required: true, message: '请输入经销商名称' }]"
          />
          
        </div>
        <div class="retailer-phone">
          <input
            v-model="formData.phone"
            id="phone"
            input-align="left"
            autocomplete="off"
            placeholder="联系方式"
            :rules="[{ required: true, message: '请输入联系方式' }]"
          >
        </div>
        <img
          class="submit"
          @click="submit"
          src="../assets/img/read/submit.png"
          alt=""
        /> 
      </div>
      <div class="erweima">
        <img src="../assets/img/read/erweima.png" alt="">
      </div>
      <div  class="business">
        <img  v-show="isDialog" class="business-img1" src="../assets/img/read/dialog.png" alt="">
        <img  class="business-img2" @click="toDialog" src="../assets/img/read/business.png" alt="">     
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  mame: "read",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption1: {
        loop: true,
        slidesPerView: 3, //一屏显示3张图片
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption2: {
        loop: true,
        slidesPerView: 3, //一屏显示3张图片
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        spaceBetween: 4,
        centeredSlides: true,
      },
      bannerImg: [
        {
          img: require("../assets/img/read/mouse.png"),
        },
        {
          img: require("../assets/img/read/mouse.png"),
        },
        {
          img: require("../assets/img/read/mouse.png"),
        },
      ],
      bannerBookImg: [
        {
          img: require("../assets/img/read/newbook1.png"),
        },
        {
          img: require("../assets/img/read/newbook2.png"),
        },
        {
          img: require("../assets/img/read/newbook2.png"),
        },
        {
          img: require("../assets/img/read/newbook2.png"),
        },
        {
          img: require("../assets/img/read/newbook2.png"),
        },
      ],
      formData: {
        distributor_name: "",
        phone: "",
      },
      isDialog:false,
      bannerNum:1
    };
  },
  created: function () {},
  mounted() {},
  methods: {
    swiperNextOne() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    swiperPreOne() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiperNextTwo() {
      this.bannerNum ++;
      if(this.bannerNum > 5){
        this.bannerNum = 1
      }
      console.log(this.bannerNum)
      this.$refs.mySwiperTwo.swiper.slideNext();
    },
    swiperPreTwo() {
      this.bannerNum--;
      if(this.bannerNum < 1){
        this.bannerNum = 5
      }
      this.$refs.mySwiperTwo.swiper.slidePrev();
    },
    changeBanner(e, i) {},
    submit() {
      this.$message({
        message: "提交成功！",
        type: "success",
      });
      this.$ajax
        .post("/recruit", this.formData)
        .then((res) => {
          if (res.status == 200) {
            this.$message({
              message: "提交成功！",
              type: "success",
            });
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
          $("#form")[0].reset();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toDialog(){
      this.isDialog = !this.isDialog
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";
@import "../assets/css/fixed";

.container {
  margin: 0;
  padding: 0;
  height: auto;
  .page {
    height: auto;
    background: url("../assets/img/read/background.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .read{
      .readImg1{
        margin-top: 19rem;
        width: 80%;
        margin-left: 10%;
         @media screen and (min-height:1000px){
          margin-top: 34rem;
        }
      }
    }
    .haoqi{
      .haoqiImg1{
        width: 80%;
        margin-left: 10%;
      }
    }
    .product {
      .product-img1 {
        margin-top: 4rem;
        width: 80%;
        margin-left: 10%;
      }
      .productback {
        background: url("../assets/img/read/productbookback.png");
        background-size: cover;
        display: flex;
        justify-content: space-between;
        height: 14rem;
        @media screen and (min-height:1000px){
          height: 30rem;
        }
        .product-img2 {
          width: 55%;
          height: 65%;
          padding: 2rem 1rem;
        }
        .product-img3 {
          width: 20%;
          height: 30%;
        }
      }
      .product-img4 {
        width: 28%;
        height: 100%;
        margin-top: -5rem;
        float: right;
      }
    }
    .recommendPage {
      width: 100%;
      height: 9rem;
      .swiper-slide {
        margin-top: 1rem;
        text-align: center;
        width: 20%;
        img {
          width: 90%;
          height: 90%;
        }
      }
      .swiper-slide-active {
        z-index: 999 !important;
        transform: scale(1.2);
      }
      .swiper-button-prev {
        background-image: url("../assets/img/read/pre.png");
        position: relative;       
        top: -3rem;
        left: 0.3rem;
        // background-position: center;
        // position:absolute;
        z-index: 100;
        width: 2rem;
        @media screen and (min-height:1000px){
          top: -6rem;
          left: 2rem;
        }
      }
      .swiper-button-next {
        background-image: url("../assets/img/read/next.png");     
        position: relative;       
        top: -4.3rem;
        left: 90%;
        background-position: center;
        // position:absolute;
        z-index: 100;
        @media screen and (min-height:1000px){
          top: -7rem;
        }
      }
    }
    .mouse {
      text-align: center;
      .mousetitle {
        display: block;
        color: #7e4a10;
        font-size: 1.7rem;
        font-weight: 900;
      }
      .mousetext {
        text-align: left;
        display: block;
        padding: 1.5rem 2rem;
        color: #7e4a10;
        font-size: 0.8rem;
        font-weight: 900;
      }
    }
    .newbook {
      margin-top: 0.5rem;
      .newbookImg{
        width: 80%;
        margin-left: 10%;
      }
      .newbook-banner {
        width: 100%;
        height: auto;
        .swiper-container{
          height: 8rem;
        }
        .swiper-slide {
          margin-top: 1rem;
          text-align: center;
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .swiper-slide-active {
          z-index: 999 !important;
          transform: scale(1.6, 1.4);
          transform-origin: 50% 60% 0;
        }
        .swiper-button-prev {
          background-image: url("../assets/img/read/pre.png");
          position: relative;       
          top: 3.8rem;
          left: 0.8rem;
          background-position: center;
          // position:absolute;
          z-index: 100;
          @media screen and (min-height:1000px){
          top: 4rem;
          left: 3rem;
        }
        }
        .bannerpros {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          width: 80%;
          margin-left: 10%;
          margin-top: 1rem;
          .bannerpro {
            width: 3rem;
            height: 3rem;
            background: url("../assets/img/read/bannerpros.png");
            border-radius: 50%;
          }
          .bannerpro-active{
             width: 3rem;
            height: 3rem;
            background: url("../assets/img/read/bannerpro.png");
            border-radius: 50%;
          }
        }

        .swiper-button-next {
          background-image: url("../assets/img/read/next.png");
          position: relative;       
          top: -1.7rem;
          left: 90%;
          background-position: center;
          // position:absolute;
          z-index: 100;
           @media screen and (min-height:1000px){
          top: -1.5rem;
        }
        }
      }
    }
    .planner {
      margin: 2rem 0;
      .plannerImg{
        width: 80%;
        margin-left: 10%;
      }
      .plannermes {
        margin-top: -16rem;
        width: 95%;
         @media screen and (min-height:1000px){
          margin-top: -30rem;
        }
      }
    }
    .partner {
      
      .partnerImg{
        margin: 1rem 0;
        width: 80%;
        margin-left: 10%;
      }
      .partlist {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        img {
          width: 28%;
          padding: 0.5rem 0;
          object-fit: 100% 100%;
        }
      }
    }
    .retailer {
      text-align: center;
      width: 95%;
      height: 17rem;
      background: url("../assets/img/read/retailer.png");
      background-size: 100% 100%;
      margin: 3rem 0;
       @media screen and (min-height:1000px){
          height: 25rem;
        }
      .retailer-img {
        width: 100%;
      }
      .retailer-name {    
         background-repeat: no-repeat;
        padding-top: 6rem;
        input{   
          height: 2rem;
           width: 65%;
          border: none;
          background: #f8963f;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 1rem;
          padding-left: 2rem;
          font-weight: 900;
          margin-left: 2rem;
           @media screen and (min-height:1000px){
          margin: 3rem 0 0 2rem ;
          height: 4rem;
        }
        }
        input::placeholder{
          color: #000;         
        }
      }
      .retailer-phone{
        padding: 1rem 0;
        input{   
          height: 2rem;
          width: 65%;
          border: none;
          background: #f8963f;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 1rem;
          font-weight: 900;
          padding-left: 2rem;
          margin-left: 2rem;
          @media screen and (min-height:1000px){
          height: 4rem;
        }
        }
        input::placeholder{
          color: #000;        
        }
      }
      .submit {
        width: 35%;
        margin-left: 5%;
      }
    }
    .erweima{
      margin: 0 auto;
      width: 100%;
      img{
        width: 100%;
        margin: 2rem auto;
      }
    }
    .business{
      
      .business-img1{
        position: fixed;
        right: 15%;
        bottom: 20%;
        z-index: 1000;
        width: 60%;
      }
      .business-img2{
        position: fixed;
        right: 3%;
        bottom: 30%;
        z-index: 1000;
        width: 2.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/read.vue